import CustomForm from "../Util/Form/CustomForm/CustomForm";
import CustomFormContainer from "../Util/Form/CustomForm/CustomFormContainer";
import config from "../../../../application/config/config";
import Fetch from "../../../util/core/Fetch";
import { getUserSession } from "../../../util/core/Session";
import { useState, useEffect } from "react";

function Form() {
  const session = getUserSession();
  const [formContent, setFormContent] = useState(<>Carregando...</>);
  const id = session.user.id;

  const endpointBackend = config.endpoints.backend;

  const paths = {
    endpointSave: endpointBackend + "core/emailaccounts/editconfigs",
    endpointGetById: endpointBackend + "core/emailaccounts/getconfigs",
  };

  let labelTitle = "Configurações do Email";

  const getForm = (values) => {
    const form = {
      labelTitle: labelTitle,
      validateOnChange: true,
      showGoBackButton: false,
      id: id,
      afterSubmit: (form, values) => {},
      fields: [
        {
          name: "sender_name",
          type: "text",
          label: "Nome do Remetente",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "sender_email",
          type: "text",
          label: "Email do Remetente",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "domain",
          type: "text",
          label: "Domínio",
          validations: {
            required: true,
          },
          columnSize: 12,
        },
        {
          name: "login",
          type: "text",
          label: "Login",
          validations: {
            required: true,
          },
          columnSize: 6,
        },
        {
          name: "password",
          type: "password",
          label: "Senha",
          validations: {
            required: true,
          },
          columnSize: 6 ,
        },
        {
          name: "smtp_address",
          type: "text",
          label: "Endereço SMTP",
          validations: {
            required: true,
          },
          columnSize: 6,
        },
        {
          name: "port",
          type: "text",
          label: "Porta",
          validations: {
            required: true,
          },
          columnSize: 2,
        },
      ],
      customValidators: {},
      ...paths,
    };

    form.values = values;
    return form;
  };

  useEffect(() => {
    const load = async () => {
      let values = {};

      if (id) {
        values = await Fetch.post(paths.endpointGetById);
      }
      const form = getForm(values);
      setFormContent(<CustomFormContainer form={form} content={<CustomForm form={form} />} />);
    };
    load();
  }, []);

  return <div>{formContent}</div>;
}
export default Form;
